import { Button } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function ContinueMinStdReportButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate({ to: `/minimal-standards/report/gather`, search: true });
  };

  return (
    <Button
      size="xs"
      onClick={onClick}
    >
      {t('minStd.toIndicators')}
    </Button>
  );
}
